import type { Cell } from '@vedalib/editor/lib/elements'
import { textToRtValue } from '@vedalib/rich-text'
import cn from 'classnames'

import RichText from 'components/form/RichText/RichText'
import { PreviewMode } from 'services/Store/Project/enums'
import { IBlockMode } from 'services/Store/Project/types'

import { useTableContext } from '../../TableContext'
import * as s from './Cell.module.scss'
import { getCellStyles } from './getCellStyles'

type SimpleCellProps = {
  cell: Cell
  indexRow: number
  index: number
  mode: IBlockMode
  // styles: CSSProperties
}

const SimpleCell = ({ cell, index, indexRow, mode }: SimpleCellProps) => {
  const { styles, cellNodes, tableValue, waiting, font, onChangeCellText } = useTableContext()
  const width = tableValue.columns[index].width

  const cellStyles = {
    ...getCellStyles({
      cell,
      row: indexRow,
      col: index,
      headerColumn: tableValue.headerColumn,
      headerRow: tableValue.headerRow,
      styles,
    }),
    width,
    minWidth: width,
    height: cellNodes[indexRow][index].clientHeight,
  }

  return (
    <td className={cn(s.td)} style={cellStyles}>
      <pre className={cn(s.root)}>
        <span className={s.span} /* style={{ fontFamily: cellStyles?.fontFamily }} */>
          <RichText
            active={false}
            isPreview={mode?.previewMode !== PreviewMode.editor}
            key={`table.${indexRow}.${index}`}
            name={`table.${indexRow}.${index}`}
            onChange={(val) => onChangeCellText(val, indexRow, index)}
            styles={font}
            value={cell.value || textToRtValue(' ')}
            waiting={waiting}
            disabled
          />
        </span>
      </pre>
    </td>
  )
}

export default SimpleCell
